import React from "react";
import config from "./../../services/config.json";
import NumberFormat from "react-number-format";
import Counter from "./counter/Counter";
import { useContext } from "react";
import SimpleContext from "./../context/SimpleContext";
import { useEffect } from "react";
import fave_false from "../img/fave_false.png";
import fave_true from "../img/fave_true.png";
import ProductBtn from "../Buttons/ProductBtn";
import Preloader from "../Preloader/preloader";
import Tarhs from "../Tarh/Tarhs";

const Product = () => {
  const context = useContext(SimpleContext);
  return (
    <>
      {context.productsDetails !== null ||
      context.productsDetails !== undefined ? (
        Object.values(context.productsDetails).length > 0 &&
        context.showPrepage === true ? (
          <Preloader />
        ) : (
          <div className="products">
            {context.productsDetails.hasDiscountOffer !== undefined &&
            context.productsDetails.hasDiscountOffer !== "" ? (
              <div
                style={{
                  position: "absolute",
                  top: "10px",
                  left: "10px",
                  backgroundColor: "#ff7014",
                  borderRadius: "20px",
                  color: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <p style={{ margin: "0", padding: "6px" }}>
                  {context.productsDetails.hasDiscountOffer}
                </p>
              </div>
            ) : null}

            {context.productsDetails.baseDiscount !== undefined &&
            context.productsDetails.baseDiscount !== 0 ? (
              <div
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  backgroundColor: "#ff7014",
                  borderRadius: "20px",
                  color: "#fff",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <p
                  style={{ margin: "0", padding: "6px" }}
                >{`${context.productsDetails.baseDiscount} %`}</p>
              </div>
            ) : null}
            {context.productsDetails.imageUrl !== undefined && (
              <div className="productsImg">
                <img
                  style={{ width: "90%" }}
                  src={context.productsDetails.imageUrl}
                />
              </div>
            )}

            <div className="productsfav">
              {context.productsDetails.fave !== undefined &&
              context.productsDetails.fave === true ? (
                <img
                  onClick={() =>
                    context.goFavorate(
                      context.productsDetails.productRef,
                      false
                    )
                  }
                  style={{ width: "30px", marginLeft: "10px" }}
                  src={fave_true}
                />
              ) : (
                <img
                  onClick={() =>
                    context.goFavorate(context.productsDetails.productRef, true)
                  }
                  style={{ width: "30px", marginLeft: "10px" }}
                  src={fave_false}
                />
              )}
            </div>

            <div className="productsInfo">
              <div className="productsInfoDetails">
                <p
                  style={{
                    margin: "0",
                    display: "flex",
                    justifyContent: "flex-start",
                    width: "100%",
                    fontWeight: "bold",
                  }}
                >
                  {context.productsDetails.productName}
                </p>
              </div>
              {context.productsDetails.price !== undefined && (
                <div
                  style={{ justifyContent: "space-between" }}
                  className="productsInfoDetails"
                >
                  <p
                    style={{
                      margin: "0",
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                    }}
                  >
                    قیمت فروش هر واحد
                  </p>
                  <p
                    style={{
                      margin: "0",
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                      gap: "5px",
                    }}
                  >
                    <NumberFormat
                      value={context.productsDetails.price}
                      displayType={"text"}
                      thousandSeparator={true}
                    />{" "}
                    <p style={{ margin: "0" }}>ریال</p>
                  </p>
                </div>
              )}

              {context.productsDetails.userPrice !== undefined && (
                <div
                  style={{ justifyContent: "space-between" }}
                  className="productsInfoDetails"
                >
                  <p
                    style={{
                      margin: "0",
                      display: "flex",
                      justifyContent: "flex-start",
                      width: "100%",
                    }}
                  >
                    قیمت مصرف کننده
                  </p>
                  <p
                    style={{
                      margin: "0",
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                      gap: "5px",
                    }}
                  >
                    <NumberFormat
                      value={context.productsDetails.userPrice}
                      displayType={"text"}
                      thousandSeparator={true}
                    />{" "}
                    <p style={{ margin: "0" }}>ریال</p>
                  </p>
                </div>
              )}
            </div>

            <div
              style={{ backgroundColor: "#e5e5e5" }}
              className="tarhMainPartDiv"
            >
              {context.productsDetails.discounts !== undefined &&
              // Object.values(context.productsDetails).length>0&&
              context.productsDetails.discounts.length > 0 ? (
                <p
                  style={{
                    margin: "0",
                    fontWeight: "bold",
                    color: "#ff7014",
                    marginBottom: "3%",
                  }}
                >
                  طرح های فروش محصول
                </p>
              ) : null}
              {
                context.productsDetails.discounts !== undefined &&
                // Object.values(context.productsDetails).length>0&&
                context.productsDetails.discounts.length > 0
                  ? context.productsDetails.discounts.map((i) => (
                      <div className="tarh_Div" key={i}>
                        <Tarhs
                          // images = {Disc.Img}
                          title={i.discountTitle}
                          kfpVnDiscountId={i.kfpVnDiscountId}
                          // prdcode = {Disc.prdcode}
                          Description={i.discountDec}
                          step={i.steps}
                          imageLink={i.imageLink}
                          // DiscountGroup = {Disc.DiscountGroup}
                        />
                      </div>
                    ))
                  : null
                // :
                // null
              }
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "100px",
                position: "fixed",
                bottom: "0",
                backgroundColor: "#fff",
              }}
            >
              <ProductBtn Product={context.productsDetails} />
            </div>
          </div>
        )
      ) : null}
    </>
  );
};

export default React.memo(Product);
